import React, { useState } from 'react'
import ReactTable from 'react-table';
import { Row, Col, Card, Button, Input } from 'reactstrap';
import NotificationSettings from './NotificationSettings';
import CustomModal from '../../../../../../Components/Modals/CustomModal';
import DisplayObject from './DisplayObject';

function ProactiveMonitoringOtherTypes(props) {
  const [searchText, setSearchText] = useState("");

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const filteredData = props.newTypeData
  ? props.newTypeData.filter((item) => {
      const search = (searchText || "").toLowerCase();

      return (
        (item.store_name || "").toLowerCase().includes(search) ||
        String(item.integerid || "").includes(search) ||
        (item.asin || "").toLowerCase().includes(search) ||
        (item.type || "").toLowerCase().includes(search) ||
        (item.old_value || "").toString().toLowerCase().includes(search) ||
        (item.new_value || "").toString().toLowerCase().includes(search) ||
        (item.status || "").toLowerCase().includes(search)
      );
    })
  : [];


  const columns = [

    {
      Header: "Store Name",
      accessor: "store_name",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p title={cellInfo.value} className="m-0 comment-paragraph-account-storeuser"><DisplayObject data={cellInfo.value} /></p>
        </div>
      ),

    },
    // {
    //   Header: "IntegerId",
    //   accessor: "integerid",
    //   Cell: (cellInfo) => (
    //     <div className="d-flex justify-content-center w-100">
    //       <p title={cellInfo.value} className="m-0 comment-paragraph-Amazon-Alert-table">{cellInfo.value}</p>
    //     </div>
    //   ),

    // },
    {
      Header: "Asin",
      accessor: "asin",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p title={cellInfo.value} className="m-0 comment-paragraph-Amazon-Alert-table">{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header: "Type",
      accessor: "type",
      width: 300,
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p title={cellInfo.value} className="m-0 comment-paragraph-ticket-history">{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header: "Old Value",
      accessor: "old_value",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p title={cellInfo.value} className="m-0 comment-paragraph-project-storename"><DisplayObject data={cellInfo.value} /></p>
        </div>
      ),
    },
    {
      Header: "New Value",
      accessor: "new_value",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p title={cellInfo.value} className="m-0 comment-paragraph-project-storename"><DisplayObject data={cellInfo.value} /></p>
        </div>
      ),
    },
    {
      Header: "Status",
      accessor: "status",
      width: 100,
    },
  ];

  return (
    <>
      <Col md={12} className="mt-3">
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="m-0">
            <b>NEW TYPES</b>
          </h5>
          <div className="d-flex justify-content-end">
            <Input
              type="text"
              placeholder="Search New Types..."
              value={searchText}
              onChange={handleSearchChange}
              className= "w-100 mr-1"
            />
          </div>
        </div>
      </Col>

      <Col md={12}>
        <ReactTable
          data={filteredData}
          columns={columns}
          className="-fixed -highlight -striped mt-2"
          getTheadProps={() => {
            return {
              style: {
                overflowY: "hidden",
                background: "#B1FA63",
                color: "#243837",
              },
            };
          }}
          defaultPageSize={5}
          noDataText={"No Data Found."}
        />

      </Col>
    </>
  )
}

export default ProactiveMonitoringOtherTypes
